import moment from "moment";
import { OrderConditions } from "src/app/@core/constants";
import { Bomb } from "../bomb";
import { Branch } from "../branch";
import { CustomerCreditValidation } from "../customer-credit-validation";
import { Order } from "../order";
import { OrderEntry } from "../order-entry";
import { CreditPolicyResponseModel } from "../response/credit-policy-response";
import { CustomerCreditStatusResponse } from "../response/customer-credit-status-response";
import { SalesOrg } from "../sales-org";
import { CustomerTableModel } from "../table-models/customer-table";
import { LoanFormRequest } from "./loan-form-request";

export class LoanSimulationRequest {

    salesOrg: string;
    customerCode: string;
    amount: number;
    currency: string;
    branchCode: string;
    promotion: string;
    diluted: Boolean;
    startDate: string;
    startDateRaw: Date;
    bombs: Array<Bomb>;
    rate: string;
    downPayment: number;
    downPaymentPercentage: number;
    term: string;
    calculatedDate: string;
    rateType: string;
    cashLoan: Boolean;
    orderCode?: string;
    gracePeriod: number;
    noInterest: Boolean;
    sellerCode: string;
    intermediaries: Array<string>;
    isAgreementCustomer: Boolean;
    isThirtyDaysOrder: Boolean;
    feeAmount?: number;
    loanCode?: string;
    minTerm?: number;
    maxTerm?: number;
    minDownPayment?: number;
    maxDownPayment?: number;
    products: Array<OrderEntry>;
    selectedUserBranch: string;
    selectedUserSalesOrg: string;
    cashLoanReasonCode: string;
    cashLoanReasonDescription: string;
    constructor() {
        this.salesOrg = "";
        this.customerCode = "";
        this.amount = 0.0;
        this.currency = "HNL";
        this.branchCode = "";
        this.promotion = "";
        this.diluted = false;
        this.startDate = "";
        this.startDateRaw = new Date();
        this.bombs = [];
        this.rate = "";
        this.downPayment = 0.0;
        this.downPaymentPercentage = 0.0;
        this.term = "";
        this.calculatedDate = "";
        this.rateType = "";
        this.cashLoan = false;
        this.gracePeriod = 0;
        this.noInterest = false;
        this.sellerCode = "";
        this.intermediaries = [];
        this.isAgreementCustomer = false;
        this.isThirtyDaysOrder = false;
        this.feeAmount = 0;
        this.loanCode = "";
        this.products = [];
        this.selectedUserBranch = ""
        this.selectedUserSalesOrg = "";
        this.cashLoanReasonCode = "";
        this.cashLoanReasonDescription = "";
    }

    static buildRequest(
        order: Order,
        customerCreditConditions: CustomerCreditValidation,
        loanFormValues: LoanFormRequest,
        config: { salesOrg: SalesOrg, branch: Branch },
        intermediaries?: Array<string>,
        isMoreThanThirtyDays?: boolean,
        financedAmount?: number,
        rate?: string,
        products?: Array<OrderEntry>
    ): LoanSimulationRequest {

        let result = new LoanSimulationRequest();

        if (isMoreThanThirtyDays === true) {
            result.salesOrg = config.salesOrg.code;
            result.customerCode = order.orderCondition == OrderConditions.MORE_THAN_30_DAYS_FRANCHISED ? order.paymentResponsible.toString() : order.customerCode;
            result.amount = financedAmount || 0 - loanFormValues.downPaymenyCurrency;
            result.branchCode = config.branch.code;
            result.startDate = loanFormValues.firstFeeDate;
            result.startDateRaw = loanFormValues.firstFeeDateRaw;
            result.rate = rate || customerCreditConditions.rate.toString();
            result.downPayment = loanFormValues.downPaymenyCurrency;
            result.downPaymentPercentage = loanFormValues.downPaymentPercent;
            result.term = loanFormValues.term.toString();
            result.calculatedDate = loanFormValues.initialDate;
            result.sellerCode = order.vendor;
            result.isThirtyDaysOrder = false;
            result.feeAmount = loanFormValues.fee;
            result.loanCode = loanFormValues.loanCode || "";
            result.minDownPayment = loanFormValues.minDownPayment;
            result.maxDownPayment = loanFormValues.maxDownPayment;
            result.minTerm = loanFormValues.minTerm;
            result.maxTerm = loanFormValues.maxTerm;
            result.isAgreementCustomer = loanFormValues.isAgreementCustomer;

            if (intermediaries) {
                result.intermediaries = intermediaries;
            }
        } else {

            result.salesOrg = config.salesOrg.code;
            result.customerCode = order.customerCode;
            result.amount = order.totals.netTotal;
            result.branchCode = config.branch.code;
            result.startDate = loanFormValues.firstFeeDate;
            result.startDateRaw = loanFormValues.firstFeeDateRaw;
            result.rate = customerCreditConditions.rate.toString();
            result.downPayment = loanFormValues.downPaymenyCurrency;
            result.downPaymentPercentage = loanFormValues.downPaymentPercent;
            result.term = loanFormValues.term.toString();
            result.calculatedDate = loanFormValues.initialDate;
            result.sellerCode = order.vendor;
            result.isThirtyDaysOrder = true;
            result.feeAmount = loanFormValues.fee;
            result.loanCode = loanFormValues.loanCode || "";
            result.isAgreementCustomer = loanFormValues.isAgreementCustomer;

            if (intermediaries) {
                result.intermediaries = intermediaries;
            }
        }

        result.products = products || [];

        return result;
    }

    static cashLoanBuildRequest(customer: CustomerTableModel, customerCreditStatus: CustomerCreditStatusResponse, customerCreditPolicy: CreditPolicyResponseModel, config: { salesOrg: SalesOrg, branch: Branch }, firstFeeDate: Date, calculatedDate: Date, seller: CustomerTableModel) {
        let result = new LoanSimulationRequest();

        result.selectedUserSalesOrg = config.salesOrg.code;
        result.selectedUserBranch = config.branch.code;
        result.branchCode = "1399";
        result.salesOrg = "1300";
        result.customerCode = customer.code;
        result.rate = customerCreditPolicy.rate.toString();
        result.downPayment = 0;
        result.downPaymentPercentage = 0;
        result.amount = 2000;
        result.minDownPayment = 0;
        result.maxDownPayment = 0;
        result.term = customerCreditPolicy.term.min.toString();
        result.minTerm = customerCreditPolicy.term.min;
        result.maxTerm = customerCreditPolicy.term.max;
        result.startDate = moment(firstFeeDate).format("YYYYMMDD");
        result.calculatedDate = moment(calculatedDate).format("YYYYMMDD");
        result.sellerCode = seller.code;
        return result;
    }
}
